import React, { useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import classnames from 'classnames'
import { Content, Text, TextInput, Label, Button, Pane, Flex, Selector, DateTimePickerV2 } from '@leverege/ui-elements'

import { JsonEditorDialog, InsetSection } from '~/views'

import S from './MaintenanceEventEditorStyle.css'

const options = [
  { name : 'Downtime', value : 'downtime' },
  { name : 'Degradation', value : 'degradation' }
]

function MaintenanceEventEditor( { item, itemActions, dispatch, full, showTitle = true } ) {
  if ( !item ) return null

  const [ showJsonEditor, setShowJsonEditor ] = useState( false )
  const { id, type, startTime, endTime, description, metadata, locked = false, createdAt } = item
  const stringifiedMetadata = metadata ? JSON.stringify( metadata, null, 2 ) : null
  const onChange = ( { value, data } ) => {
    let nVal = data === 'name' && !value ? type : value
    nVal = typeof nVal === 'string' ? nVal.trim() : nVal
    dispatch( itemActions( id ).update( { [data] : nVal } ) )
    setShowJsonEditor( false )
  }
  return (
    <Pane className={classnames( S.editorPanel, { [S.full] : full } )}>
      <Content>
        {showTitle && (
          <Content.Header>
            <Pane className={S.title} variant="screenTitle">
              <Text variant="caption">Maintenance Event</Text>
              <Text variant="cardTitle">{type}</Text>
            </Pane>
          </Content.Header>
        ) }
        <Content.Area>
          <Pane className={S.formBody} variant="formBody">
            <div className={S.inputGroup}>
              <Label variant="input">Type</Label>
              <Selector
                eventData="type"
                value={type}
                onChange={onChange}
                values={options} />
            </div>
            <div className={S.inputGroup}>
              <Label variant="input">Description</Label>
              <TextInput onChange={onChange} eventData="description" value={description} />
            </div>
            <div className={S.inputGroup}>
              <Label variant="input">Start Time</Label>
              <DateTimePickerV2
                eventData="startTime"
                value={new Date( startTime )}
                onChange={onChange} />
            </div>
            <div className={S.inputGroup}>
              <Label variant="input">End Time</Label>
              <DateTimePickerV2
                eventData="endTime"
                value={new Date( endTime )}
                onChange={onChange} />
            </div>
            <div className={S.inputGroup}>
              <Text>Created {moment( createdAt ).format( 'lll' )}</Text>
            </div>
          </Pane>
        </Content.Area>
      </Content>
    </Pane>
  )
}

export default connect( ( state, props ) => {
  const { itemActions, id } = props
  return {
    item : itemActions( id ).getMaintenanceEvent( state )
  }
} )( MaintenanceEventEditor )
